





















































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { DiamondData } from "@/Helpers/DistributorDataHelper";
import { DiamondDataHelper } from "@/Helpers/DistributorDataHelper";
import PopUp from "@/components/app/PopUp.vue";
import RemoveItemDialog from "@/components/app/RemoveItemDialog.vue";
import DiamondNew from "@/components/dashboards/DiamondNew.vue";

import {
  DiamondSupportListClient,
  DsListEntryModel,
} from "@/diamond-support-api";
import { ErrorMessage, SuccessMessage } from "@/shared";

@Component({
  components: {
    PopUp,
    RemoveItemDialog,
    DiamondNew,
  },
})
export default class DiamondList extends Vue {
  @Action("showMessage", { namespace: "notification" }) showMessage: any;
  @Action("saveDistributorId", { namespace: "distributor" })
  saveDistributorId: any;
  @Action("saveDiamondList", { namespace: "diamond" }) saveDiamondList: any;

  diamondListItemsSPA: DiamondData[] | null = [];
  diamondListItemsDB: DsListEntryModel[] | null = [];
  diamondListItems: DsListEntryModel[] | null = [];
  diamondListItem: DsListEntryModel | null = null;

  diamondApi = new DiamondSupportListClient();
  diamondDataHelper = new DiamondDataHelper();

  shown = false;
  item = "";
  search = "";

  removeItem: DsListEntryModel | null = null;
  removeMessage = "";
  showRemoveDialog = false;

  showSavePopUp = false;
  saveMessage = "";
  saveItem: DsListEntryModel | null = null;

  showDiamondNew = false;

  headers: any[] = [
    {
      text: "Distributor Id",
      sortable: false,
      value: "distributorId",
      width:"15%",
    },
    {
      text: "Business Name",
      value: "businessName",
      sortable: false,
    },
    {
      text: "Name",
      value: "fullName",
      sortable: false,
    },
    {
      text: "Phone Number",
      value: "mobilePhone",
      sortable: false,
    },
    {
      text: "Email",
      value: "email",
      sortable: false,
    },
    {
      text: "Country",
      value: "country",
      sortable: false,
    },
    {
      text: "Last Paid Rank",
      value: "lastPaidRank",
      sortable: false,
    },
    {
      text: "Lifetime Rank",
      value: "lifetimeRank",
      sortable: false,
    },
    {
      text: "Enrollment Date",
      value: "enrollmentDate",
      sortable: false,
    },
    {
      text: "Renewal Date",
      value: "renewalDate",
      sortable: false,
    },
    {
      text: "Updated time",
      value: "updatedUtc",
      sortable: false,
      align: " d-none",
    },
    {
      text: "Delete",
      align: "center",
      sortable: false,
      value: "delete",
    },
    {
      text: "Save",
      align: "center",
      sortable: false,
      value: "save",
    },
  ];

  async mounted() {
    this.diamondListItemsDB = await this.diamondApi.index();
    this.diamondListItems = this.diamondListItemsDB;
  }

  removeDiamond(diamondListItem: DsListEntryModel) {
    this.removeItem = diamondListItem;
    this.removeMessage = `Are you sure you want to remove the Diamond info for distributor Id ${diamondListItem.distributorId} ?`;
    this.showRemoveDialog = true;
  }

  diamondListItemAdded(diamondListItem: DsListEntryModel) {
    this.showDiamondNew = false;
    for (let [key, value] of Object.entries(this.diamondListItems!)) {
      if (value.distributorId == diamondListItem.distributorId) return;
    }
    this.saveDiamondInfoToDB(diamondListItem);
  }

  async saveDiamondInfoToDB(diamondListItem: DsListEntryModel) {
    await this.diamondApi
      .post(diamondListItem)
      .then((response) => {
        if (response !== null)
          this.showMessage(new SuccessMessage(`New diamond has been added.`));
        this.diamondListItems!.push(Object.assign({}, diamondListItem));
      })
      .catch((error) => {
        console.log(error);
        this.showMessage(new ErrorMessage(`An error occured: \r\n${error}`));
      });
  }

  newDiamondListItem() {
    this.showDiamondNew = true;
  }

  showAssociateDetail(distributorId: string) {
    this.saveDistributorId(distributorId);
    this.$router.push({
      path: `/associates/${distributorId}/detail`,
    });
  }

  saveDiamondListItem(diamondListItem: DsListEntryModel) {
    this.saveItem = diamondListItem;
    this.saveMessage = `Are you sure you want to save the diamond info for distributor Id ${diamondListItem.distributorId} ?`;
    this.showSavePopUp = true;
  }

  customSort() {
    return this.diamondListItems!.sort((a, b) => {
      return <any>new Date(b.updatedUtc!) - <any>new Date(a.updatedUtc!);
    });
  }

  diamondRemoved(diamondListItem: DsListEntryModel) {
    let index = this.diamondListItems!.map(function (x) {
      return x.id;
    }).indexOf(diamondListItem.id);
    if (index >= 0) this.diamondListItems!.splice(index, 1);
  }

  diamondSaved(diamondListItem: DsListEntryModel) {
    let index = this.diamondListItems!.map(function (x) {
      return x.distributorId;
    }).indexOf(diamondListItem.distributorId);
    if (index >= 0) this.diamondListItems!.splice(index, 1, diamondListItem);
  }

  async confirmRemove() {
    if (this.removeItem && this.removeItem.distributorId) {
      await this.diamondApi
        .delete(this.removeItem.distributorId)
        .then((response) => {
          if (response !== null) this.diamondRemoved(this.removeItem!);
          this.showMessage(
            new SuccessMessage(`the diamond info has been deleted.`)
          );
        })
        .catch((error) => {
          console.log(error);
          this.showMessage(new ErrorMessage(`An error occured: \r\n${error}`));
        });
    }
    this.showRemoveDialog = false;
  }

  async confirmSave() {
    if (this.saveItem) {
      await this.diamondApi
        .post(this.saveItem)
        .then((response) => {
          if (response !== null) {
            this.diamondSaved(this.saveItem!);
            this.showMessage(
              new SuccessMessage(`the diamond info has been saved.`)
            );
          }
        })
        .catch((error) => {
          console.log(error);
          this.showMessage(new ErrorMessage(`An error occured: \r\n${error}`));
        });
    }
    this.saveItem!.isSpaData = false;
    this.showSavePopUp = false;
  }
}
